var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPricingPotential(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 2253 2250",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    fillRule: "evenodd",
    clipRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 1.5,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.997 0h2250v2250h-2250z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m310.331 408.413-100-200-100 200h200ZM1885.33 1983.41l200 100-200 100v-200Z",
    fill: "#75b6e1",
    className: "fill-202020"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M210.331 368.413v1715h1715",
    fill: "none",
    stroke: "#75b6e1",
    strokeWidth: "66.67px",
    className: "stroke-202020"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m418.664 625 625 416.667 208.333-412.5 625 622.916",
    fill: "none",
    stroke: "#75b6e1",
    strokeWidth: "66.67px",
    className: "stroke-202020"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m418.664 1875 625-625 208.333 416.667 625-1037.5",
    fill: "none",
    stroke: "#75b6e1",
    strokeWidth: "66.67px",
    className: "stroke-202020"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m418.664 1875 625-625 208.333 416.667 625-1037.5",
    fill: "none",
    stroke: "#75b6e1",
    strokeWidth: "66.67px",
    className: "stroke-202020"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPricingPotential);
export default __webpack_public_path__ + "static/media/pricing_potential.9387c2c76225688d9fdc3711be8ec9be.svg";
export { ForwardRef as ReactComponent };